export default "__VITE_ASSET__DQM8wdbW__"